import React from 'react';
import { INSTAGRAM_LINK, SUPPORT_EMAIL, WHATSAPP_LINK } from './Shared';
export function Footer() {
  return <footer className="border-t border-brand-gold/40 bg-brand-blueDeep py-12 text-brand-cream" data-id="element-108" data-mp="3gfiswe27a3c0">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8" data-id="element-109" data-mp="32onk11rpbm8f">
        <div className="mb-8 rounded-2xl border border-white/10 bg-white/5 p-6 text-sm leading-relaxed" data-id="element-110" data-mp="36p6dt1d5n2d9">
          <p data-id="element-111" data-mp="3ufa7afwmplqj">
            <strong className="text-brand-goldLight" data-id="element-112" data-mp="3uesczotj1hl9">P.D.:</strong> Si tienes dudas, escríbenos a{' '}
            <a className="font-semibold text-brand-amber hover:underline" href={`mailto:${SUPPORT_EMAIL}`} data-id="element-113" data-mp="38zawx2kd95j">
              {SUPPORT_EMAIL}
            </a>{' '}
            o por{' '}
            <a className="font-semibold text-brand-amber hover:underline" href={WHATSAPP_LINK} data-id="element-114" data-mp="3qcxbokblj47h">
              WhatsApp
            </a>
            . También puedes encontrarnos en Instagram como{' '}
            <a className="font-semibold text-brand-amber hover:underline" href={INSTAGRAM_LINK} data-id="element-115" data-mp="2eyt6ehzk5tn4">
              @lumen.akasha
            </a>
            . Te respondemos hoy.
          </p>
          <p className="mt-3 italic text-brand-cream/75" data-id="element-116" data-mp="3gapcfgy9ogex">
            El precio especial de lanzamiento es por tiempo limitado. El mejor momento para tener tu sistema
            profesional de Biodescodificación es ahora.
          </p>
        </div>

        <div className="mb-10 flex flex-col items-center justify-center gap-4 text-sm md:flex-row md:gap-7" data-id="element-117" data-mp="3q725cclzmq8m">
          <a className="transition-colors duration-150 ease-out hover:text-brand-amber" href={`mailto:${SUPPORT_EMAIL}`} data-id="element-118" data-mp="817cg38o1ksh">
            📧 {SUPPORT_EMAIL}
          </a>
          <a className="transition-colors duration-150 ease-out hover:text-brand-amber" href={INSTAGRAM_LINK} data-id="element-119" data-mp="hrs6dddea152">
            📲 @lumen.akasha
          </a>
          <a className="transition-colors duration-150 ease-out hover:text-brand-amber" href="https://www.lumenakasha.com" data-id="element-120" data-mp="cw3617tjwg7p">
            🌐 www.lumenakasha.com
          </a>
        </div>

        <div className="mb-8" data-id="element-121" data-mp="mptqm1mk46i4">
          <h3 className="mb-2 font-display text-3xl font-bold text-brand-goldLight" data-id="element-122" data-mp="tvczxt1gc7fo">LUMEN AKASHA™</h3>
          <p className="text-brand-cream/80" data-id="element-123" data-mp="yto9e2nu4fxd">
            Recursos digitales educativos para terapeutas y facilitadores de Biodescodificación.
          </p>
          <p className="mt-2 text-brand-cream/70" data-id="element-124" data-mp="13rzg44iu2abd">
            Herramientas creadas para aportar mayor organización, claridad y estructura a tu práctica.
          </p>
        </div>

        <div className="space-y-2 border-t border-white/10 pt-6 text-xs text-brand-cream/50" data-id="element-125" data-mp="1cl2t6bpkgl5h">
          <p data-id="element-126" data-mp="1hje0ofse2jkj">
            © Lumen Akasha™ 2025 — Todos los derechos reservados. Prohibida la reproducción y redistribución sin
            autorización expresa.
          </p>
          <p data-id="element-127" data-mp="1rj4xwp8c3cob">
            Material digital educativo · Disponible en Latinoamérica · Los modelos de documentos deben adaptarse a la
            legislación de cada país.
          </p>
        </div>
      </div>
    </footer>;
}